import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=236a3a85&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=236a3a85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a3a85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236a3a85')) {
      api.createRecord('236a3a85', component.options)
    } else {
      api.reload('236a3a85', component.options)
    }
    module.hot.accept("./noticeDetail.vue?vue&type=template&id=236a3a85&scoped=true", function () {
      api.rerender('236a3a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/notice/components/noticeDetail.vue"
export default component.exports